import axios from 'axios'
import store from '@/store'
import Vue from 'vue'
import i18n from '@/i18n'

import retryList from './retryList'

let FLAG = false
let saveConfigs = {}

const service = axios.create({
  // baseURL: baseUrl
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 30 * 1000, // 请求超时时间
  retry: 0, // 设置全局重试请求次数（最多重试几次请求）
  retryDelay: 1000, // 设置全局请求间隔
})

// 请求拦截处理
service.interceptors.request.use(config => {
  // console.log(`%cconfig:`, 'color: #f00;', config)
  if (config.url === '/js/debug') {
    return config
  }
  store.commit('el_loading_x_save', true)
  // if (config.data && store.state && store.state.shop_x) {
  //   config.data.shopId = store.state.shop_x.id
  // }
  return config
}, error => {
  // console.log(`%cerror:`, 'color: #f00;', error)
  Promise.reject(error)
})

// 响应拦截处理
service.interceptors.response.use(resp => {
  // console.log(`%cresp.config:`, 'color: #f00;', resp.config)

  store.commit('el_loading_x_save', false)

  const { method, url } = resp.config
  const ITEM = retryList.find(x1 => x1.method === method && x1.url === url)
  // console.log(`%cITEM:`, 'color: #f00;', ITEM)
    if (ITEM) {
    // console.log(`%c可以删除`, 'color: #f00;')
    delete saveConfigs[`${url}/${method}`] 
  }

  if (resp.status === 200) {
    return resp.data
  } else {
    store.commit('el_loading_long_x_save', false)
    return { status: 400, msg: '网络错误' }
  }
}, error => {
  // console.log(`%cresp.response:`, 'color: #f00;', error.response)
  // console.log(`%cerror.message:`, 'color: #f00;', error.message)
  // console.log(`%cerror.name:`, 'color: #f00;', error.name)
  // console.log(`%cerror.config:`, 'color: #f00;', error.config)

  store.commit('el_loading_x_save', false)
  store.commit('el_loading_long_x_save', false)

  const { method, url } = error.config
  const ITEM = retryList.find(x1 => x1.method === method && x1.url === url)
  // console.log(`%cITEM:`, 'color: #f00;', ITEM)
  if (ITEM) {
    // console.log(`%c可以重新请求`, 'color: #f00;')
    saveConfigs[`${url}/${method}`] = error.config
  }

  // console.log(`%cFLAG:`, 'color: #00f;', FLAG)
  if (!FLAG) {
    FLAG = true
    // #region confirm提示框
    // Vue.prototype.$confirm(i18n.t('common.netError'), i18n.t('common.tips'), {
    //   confirmButtonText: i18n.t('common.comfirm'),
    //   showCancelButton: false,
    //   type: 'error',
    //   distinguishCancelAndClose: true,
    // }).then(res => {
    //   resendAjax()
    // }).catch(res => {
    //   resendAjax()
    // })
    // #endregion
    const autoOnlyBendRead = error.config && error.config.data && JSON.parse(error.config.data)
      ? JSON.parse(error.config.data).autoOnlyBendRead
      : false
    console.log(`%cautoOnlyBendRead:`, 'color: #f00;', autoOnlyBendRead)
    Vue.prototype.$message({
      type: 'error',
      message: i18n.t(autoOnlyBendRead || ITEM ? 'common.netErrorCheck' : 'common.netErrorTryAgain'),
      showClose: true,
      onClose: resendAjax,
    })
  }
  return Promise.reject(error.response)
})

function resendAjax() {
  FLAG = false

  // console.log(`%c确认重新请求`, 'color: #f00;')
  Object.keys(saveConfigs).forEach(x1 => {
    service(saveConfigs[x1])
  })
}


// 封装get请求方法
function get(url, params = {}) {
  params.t = new Date().getTime() // get方法加一个时间参数,解决ie下可能缓存问题.
  return service({
    url,
    method: 'get',
    headers: {
      'bEndRequest': 'true',
    },
    params,
  })
}
var sendObject = {
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    'bEndRequest': 'true',
  },
}
function paramsHandler(url, data) {
  sendObject.url = url
  sendObject.data = JSON.stringify(data)
  return service(sendObject)
}
// 封装post请求方法
function post(url, data = {}) {
  sendObject.method = 'post'
  return paramsHandler(url, data)
}
// 封装put请求方法 (resfulAPI常用)
function put(url, data = {}) {
  sendObject.method = 'put'
  return paramsHandler(url, data)
}
// 封装delete请求方法 (resfulAPI常用)
function deletes(url, data = {}) {
  sendObject.method = 'delete'
  return paramsHandler(url, data)
}
export {
  service,
  get,
  post,
  put,
  deletes,
}